import { Navigate, Outlet, useLocation } from 'react-router-dom';
import type { UserRole } from '@agenda-facil/contracts';
import { useAuthStore } from '../stores/auth-store';

export function ProtectedRoute({ roles }: { roles?: UserRole[] }) {
  const user = useAuthStore((state) => state.user);
  const location = useLocation();
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  if (roles && !roles.includes(user.role)) {
    return <Navigate to={user.shopId ? '/app' : '/'} replace />;
  }
  return <Outlet />;
}
